import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const gpsinsightConfig: TSPConfig = {
  key: 'gpsinsight',
  name: 'GPS Insight',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials you use to log into the GPS Insight web app.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default gpsinsightConfig;
